module.exports = __webpack_public_path__ + "videos/banners.816d475.mp4";